"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_1 = require("../service");
var createProfile = function (values) {
    return (0, service_1.getService)()
        .post('/signup', { user: values })
        .then(function (response) { return response; })
        .catch(function (_a) {
        var response = _a.response;
        return Promise.reject(response);
    });
};
exports.default = createProfile;
